import { TRIP_NUMBERS_FILTER_TEXT } from './texts';

/**
 * @typedef {object} TripNumberOption
 * @property {string} title
 * @property {string} subtitle
 */

/**
 * Produce the autocomplete options for the trip-number filter.
 *
 * The input is a free-form string typed by the user. When non-empty, a single
 * synthesized option is returned so selecting it adds a token to the filter
 * store. Empty input yields no options.
 *
 * @param {string} typed
 * @returns {TripNumberOption[]}
 */
export const buildTripNumberOptions = (typed) => {
	if (!typed) return [];
	return [
		{
			title: typed,
			subtitle: TRIP_NUMBERS_FILTER_TEXT.optionSubtitle,
		},
	];
};
